import { Tool } from '../../types';

export const hrTools: Tool[] = [
  {
    id: 'gusto',
    name: 'Gusto',
    category: 'HR & Payroll',
    description: 'All-in-one payroll, benefits, and HR platform designed for small businesses. Automate payroll taxes, offer health insurance, manage PTO, and handle onboarding. Rated the top payroll software for its user-friendly interface and expert support.',
    pricing: ['medium', 'high'],
    features: ['automation', 'integrations', 'mobile', 'security'],
    bestFor: ['small-business', 'startup'],
    compatibleWith: ['service-business', 'agency', 'consulting-firm'],
    goals: ['streamline-operations', 'reduce-costs'],
    industries: ['technology', 'retail', 'creative'],
    website: 'https://gusto.com',
    imageUrl: 'https://logo.clearbit.com/gusto.com',
    idealStages: ['growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'small'
  },
  {
    id: 'bamboohr',
    name: 'BambooHR',
    category: 'HR & Payroll',
    description: 'Award-winning HR software that centralizes employee data, time-off tracking, performance management, and hiring. Beautiful, intuitive interface loved by HR teams and employees alike. Reduces HR busywork so you can focus on people.',
    pricing: ['medium', 'high'],
    features: ['ease-of-use', 'mobile', 'integrations'],
    bestFor: ['small-business', 'startup'],
    compatibleWith: ['service-business', 'agency'],
    goals: ['streamline-operations', 'automate-tasks'],
    industries: ['technology', 'marketing', 'consulting'],
    website: 'https://www.bamboohr.com',
    imageUrl: 'https://logo.clearbit.com/bamboohr.com',
    idealStages: ['growing', 'scaling'],
    technicalLevel: ['intermediate'],
    minTeamSize: 'small'
  },
  {
    id: 'rippling',
    name: 'Rippling',
    category: 'HR & Payroll',
    description: 'Unified workforce platform connecting HR, IT, and Finance operations. Onboard new employees in 90 seconds with automatic provisioning of payroll, benefits, devices, and app access. Scales from 2 to 2,000+ employees seamlessly.',
    pricing: ['medium', 'high'],
    features: ['automation', 'integrations', 'security', 'scalability'],
    bestFor: ['startup', 'small-business'],
    compatibleWith: ['saas', 'agency', 'consulting-firm'],
    goals: ['streamline-operations', 'automate-tasks'],
    industries: ['technology', 'finance', 'consulting'],
    website: 'https://www.rippling.com',
    imageUrl: 'https://logo.clearbit.com/rippling.com',
    idealStages: ['growing', 'scaling'],
    technicalLevel: ['intermediate', 'advanced'],
    minTeamSize: 'medium'
  },
  {
    id: 'gusto-contractor',
    name: 'Gusto Contractor',
    category: 'HR & Payroll',
    description: 'Streamlined solution for paying contractors and freelancers compliantly. Automatically file 1099s, collect W-9s, and make payments domestically or internationally. No monthly fees for paying contractors only.',
    pricing: ['medium'],
    features: ['automation', 'integrations', 'document-management', 'mobile'],
    bestFor: ['small-business', 'startup'],
    compatibleWith: ['service-business', 'agency', 'consulting-firm'],
    goals: ['streamline-operations', 'reduce-costs', 'automate-tasks'],
    industries: ['technology', 'creative', 'consulting'],
    website: 'https://gusto.com/contractor',
    imageUrl: 'https://logo.clearbit.com/gusto.com',
    idealStages: ['launching', 'growing'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  }
];